import { format, parseISO } from 'date-fns';

const ARTICLE_DATE_FORMAT = 'MMM, yyyy';
const ARTICLE_DETAIL_DATE_FORMAT = 'MMMM yyyy';
const EVENT_DATE_FORMAT = 'eee, MMMM d, yyyy';
const EVENT_TIME_FORMAT = 'h:mm a';

export const secondsToMMSS = (seconds: number): string => {
  return new Date(seconds * 1000).toISOString().substring(14, 19);
};

export const formatArticleDate = (date?: string, locale?: Locale) => {
  if (date) {
    return format(parseISO(date), ARTICLE_DATE_FORMAT, { locale });
  }
  return '';
};

export const formatArticleDetailDate = (date?: string, locale?: Locale) => {
  if (date) {
    return format(parseISO(date), ARTICLE_DETAIL_DATE_FORMAT, { locale });
  }
  return '';
};

export const formatEventDate = (
  startDate?: string,
  endDate?: string,
  locale?: Locale,
) => {
  if (startDate && endDate) {
    const startDay = format(parseISO(startDate), EVENT_DATE_FORMAT, { locale });
    const endDay = format(parseISO(endDate), EVENT_DATE_FORMAT, {
      locale,
    });
    if (startDay === endDay) {
      return startDay;
    }
    return `${startDay} - ${endDay}`;
  }
  return 'All Day';
};

export const formatEventTime = (startDate: string, endDate: string) => {
  const startTime = format(parseISO(startDate), EVENT_TIME_FORMAT);
  const endTime = format(parseISO(endDate), EVENT_TIME_FORMAT);
  return `${startTime} - ${endTime}`;
};
